var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenUpDownArr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3736",
    "data-name": "Group 3736",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1623",
    "data-name": "Group 1623",
    transform: "translate(0 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Forward_arrow_small",
    "data-name": "Forward arrow small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M1027.737,546l-5.01-4.8,1.216-1.2,3.783,3.628L1031.5,540l1.227,1.175Z",
    transform: "translate(-1022.727 -540)",
    fill: "#1b453e"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1623-2",
    "data-name": "Group 1623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Forward_arrow_small-2",
    "data-name": "Forward arrow small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36-2",
    "data-name": "Path 36",
    d: "M1032.727,538.739l-1.227,1.175-3.774-3.629-3.783,3.629-1.216-1.2,5.01-4.8Z",
    transform: "translate(-1022.727 -533.914)",
    fill: "#1b453e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenUpDownArr);
export default __webpack_public_path__ + "static/media/greenUpDownArr.4f527107f5aa1769bb91788aa4185a49.svg";
export { ForwardRef as ReactComponent };